import { getDefaultRibbonButtonRenderer } from 'owa-acui';
import { observer } from 'owa-mobx-react';
import loc from 'owa-localize';
import {
    lightRPOnButton,
    lightRPOffButton,
} from 'owa-mail-ribbon-utils/lib/ribbon_mail_strings.locstring.json';
import { buttonSizer, buttonSlot, sizingButton } from './LightReadingPaneButton.scss';

type Props = Parameters<ReturnType<typeof getDefaultRibbonButtonRenderer>>[0];

export const LightReadingPaneButton: React.FC<Props> = observer(function LightReadingPaneButton(
    props: Props
) {
    const lightLabel = loc(lightRPOnButton);
    const darkLabel = loc(lightRPOffButton);
    const renderButton = getDefaultRibbonButtonRenderer();

    // ACUI's responsive selectors must reach both labels through the control's root ID.
    return (
        <span className={buttonSizer} id={props.id}>
            {renderButton({
                ...props,
                id: `${props.id}-button`,
                className: props.className ? `${props.className} ${buttonSlot}` : buttonSlot,
                onExecute: parameter => props.onExecute?.({ ...parameter, id: props.id }),
            })}
            <span className={`${buttonSlot} ${sizingButton}`} aria-hidden="true">
                {renderButton({
                    ...props,
                    id: `${props.id}-sizing`,
                    label: props.label === lightLabel ? darkLabel : lightLabel,
                    keytipProps: undefined,
                    onExecute: undefined,
                    customTooltip: undefined,
                    title: undefined,
                })}
            </span>
        </span>
    );
}, 'LightReadingPaneButton');
